<div *ngIf="hasLanguageMismatch" class="alert alert-dismissible fade show" role="alert" [ngClass]="alertClass">
	<i class="{{iconClass}}"></i>
	<strong>{{title}}</strong> {{body}}
	<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="dismiss()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
